module.exports = __webpack_public_path__ + "static/favicon-ab1f1665723ab007dd6b0fe5ac3f4e95.ico";